export default {
      id: "arrow-up-s-usage",
      viewBox: "0 0 21 13",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#arrow-up-s",
      toString: function () {
        return this.url;
      }
    }